"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MWDomains = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _axios = _interopRequireWildcard(require("axios"));
var _fetchJsonp = _interopRequireDefault(require("fetch-jsonp"));
var _ActivityWatcher = _interopRequireWildcard(require("./ActivityWatcher"));
var _Unauthenticated = _interopRequireDefault(require("../errors/Unauthenticated"));
var _Unauthorized = _interopRequireDefault(require("../errors/Unauthorized"));
var _SessionHandler = _interopRequireWildcard(require("./SessionHandler"));
var _GlobalErrorHandler = _interopRequireDefault(require("./GlobalErrorHandler"));
var _Router = _interopRequireDefault(require("./Router"));
var _mainConfig = _interopRequireDefault(require("../mainConfig"));
var _MyNetworkError = _interopRequireDefault(require("../errors/MyNetworkError"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint "@typescript-eslint/no-unused-vars": 0 */
_axios.default.defaults.allowAbsoluteUrls = true;
var codeExIsInProg = false;
var MWDomains = exports.MWDomains = {
  cicAccount: 'account',
  cicCustomer: 'customer',
  cscCustomer: 'cscnCustomerDomain',
  cscAccount: 'cscnAccountDomain'
};
var apiTimeoutInMilliseconds = 150000;
var RestHelper = /*#__PURE__*/function () {
  function RestHelper() {
    (0, _classCallCheck2.default)(this, RestHelper);
  }
  (0, _createClass2.default)(RestHelper, null, [{
    key: "refreshTokens",
    value: function refreshTokens(response) {
      if (response.data && response.data.token) {
        var userAndToken = response.data.token.split(' ');
        _SessionHandler.default.initSession(userAndToken[0], userAndToken[1], _SessionHandler.default.getLoginType());
      } else if (response.headers && response.headers['x-auth-token']) {
        var _userAndToken = response.headers['x-auth-token'].split(' ');
        _SessionHandler.default.initSession(_userAndToken[0], _userAndToken[1], _SessionHandler.default.getLoginType());
      }
    }
  }, {
    key: "isCiamLogin",
    value: function isCiamLogin() {
      return _Router.default.getUrlParameter('code');
    }
  }, {
    key: "getRedirectUriWithoutQParams",
    value: function getRedirectUriWithoutQParams() {
      return window.location.href.split('?')[0];
    }
  }, {
    key: "refreshCiamToken",
    value: function refreshCiamToken() {
      var body = new FormData();
      // grant_type=refresh_token&
      // client_id=3MVG9lKcPoNINVBIPJjdw1J9LLM82HnFVVX19KY1uA5mu0QqEWhqKpoW3svG3XHrXDiCQjK1mdgAvhCscA9GE&client_secret=1955279925675241571&
      // refresh_token=your token here
      body.append('grant_type', 'refresh_token');
      body.append('redirect_uri', RestHelper.getRedirectUriWithoutQParams());
      body.append('refresh_token', _SessionHandler.default.getRefreshToken());
      body.append('client_id', _mainConfig.default.AEM_CONFIG.SSO.clientId);
      var promise = (0, _axios.default)({
        method: 'post',
        url: _mainConfig.default.AEM_CONFIG.SSO.ssoExchangeUrl,
        data: body,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      promise.then(function (response) {
        var _response$data;
        if ((_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.id_token) {
          _SessionHandler.default.setToken(response.data.id_token, 'ciam');
        }
      });
      return promise;
    }
  }, {
    key: "refreshMiddlewareToken",
    value: function refreshMiddlewareToken() {
      if (_SessionHandler.default.isUserAssignedToApp(_SessionHandler.appTypes.cscn)) {
        return this.get("".concat(this.getBaseUrl(MWDomains.cscCustomer), "/cscn-customer-srv/api/root/v0/"));
      }
      if (_SessionHandler.default.isUserAssignedToApp(_SessionHandler.appTypes.cic)) {
        return this.get("".concat(this.getBaseUrl(MWDomains.cicCustomer), "/api/root/v0"));
      }
      return Promise.resolve();
    }
  }, {
    key: "tokenExchange",
    value: function tokenExchange(code, codeVerifier) {
      var body = new FormData();
      body.append('grant_type', 'authorization_code');
      body.append('redirect_uri', RestHelper.getRedirectUriWithoutQParams());
      body.append('code', code);
      body.append('code_verifier', codeVerifier);
      body.append('client_id', _mainConfig.default.AEM_CONFIG.SSO.clientId);
      var promise = (0, _axios.default)({
        method: 'post',
        url: _mainConfig.default.AEM_CONFIG.SSO.ssoExchangeUrl,
        data: body,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return promise;
    }
  }, {
    key: "addAxiosInterceptors",
    value: function addAxiosInterceptors() {
      _axios.default.interceptors.request.use(function (config) {
        if (config.headers.captcha && config.headers.captcha === 'mock') {
          // not sure if it has any negative impact if I recreate the complete object
          // eslint-disable-next-line no-param-reassign
          delete config.headers.captcha;
        }
        return config;
      }, function (error) {
        return Promise.reject(error);
      });
    }
  }, {
    key: "initCiamTokenExchange",
    value: function initCiamTokenExchange() {
      var _this = this;
      if (codeExIsInProg) {
        return Promise.resolve();
      }
      var returnPromise = new Promise(function (resolve, reject) {
        var _SessionHandler$getCu;
        if (!_this.isCiamLogin()) {
          reject();
        }
        _SessionHandler.default.destroySession(false);
        var code = _Router.default.getUrlParameter('code');
        RestHelper.tokenExchange(code, (_SessionHandler$getCu = _SessionHandler.default.getCurrentCodeVerifier()) !== null && _SessionHandler$getCu !== void 0 ? _SessionHandler$getCu : '').then(function (reponse1) {
          codeExIsInProg = true;
          _SessionHandler.default.removeCodeVerifier();
          if (reponse1.data && reponse1.data.id_token) {
            _SessionHandler.default.initSession('Bearer', {
              accessToken: reponse1.data.id_token,
              refreshToken: reponse1.data.refresh_token
            });
            _ActivityWatcher.default.registerNewActivity();
            _ActivityWatcher.default.registerTokenRefreshing(_ActivityWatcher.tokenTypes.ciam);
            _ActivityWatcher.default.registerTokenRefreshing(_ActivityWatcher.tokenTypes.mw);
            _ActivityWatcher.default.initActivityObserving(540, function () {
              return _this.refreshCiamToken();
            }, function () {
              return _this.refreshMiddlewareToken();
            }, function () {
              return _SessionHandler.default.destroySession();
            });
          }
          resolve(reponse1);
        }).catch(function () {
          if (!_mainConfig.default.AEM_CONFIG.isAuthorMode) {
            var redirectUrl = _mainConfig.default.AEM_CONFIG.loginFailureUrl;
            location.replace(redirectUrl);
          }
          reject();
        });
      });
      return returnPromise;
    }
  }, {
    key: "getBaseUrl",
    value: function getBaseUrl(domain) {
      if (!this.baseApiURLs) {
        throw Error('API URL is not set up yet');
      }
      if (!domain) {
        return this.baseApiURLs[MWDomains.cscCustomer];
      }
      return this.baseApiURLs[domain];
    }
  }, {
    key: "initBaseURLs",
    value: function initBaseURLs(urls) {
      this.baseApiURLs = urls;
    }
  }, {
    key: "getAuthHeader",
    value: function getAuthHeader(isCiam) {
      if (!_SessionHandler.default.getName() && !_SessionHandler.default.getToken()) {
        return {};
      }
      if (isCiam) {
        return {
          Authorization: "".concat(_SessionHandler.default.getName(), " ").concat(_SessionHandler.default.getToken('ciam'))
        };
      }
      return {
        'X-Auth-Token': "".concat(_SessionHandler.default.getName(), " ").concat(_SessionHandler.default.getToken())
      };
    }
  }, {
    key: "setXClientHeader",
    value: function setXClientHeader(config, header) {
      return _objectSpread(_objectSpread({}, config), {}, {
        headers: _objectSpread(_objectSpread({}, config.headers), {}, {
          'X-Client': header
        })
      });
    }
  }, {
    key: "setConfig",
    value: function setConfig() {
      var _config$headers$XCli, _config$headers;
      var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var setAuth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var url = arguments.length > 2 ? arguments[2] : undefined;
      var middlewareDomains = _mainConfig.default.AEM_CONFIG.middlewareDomains;
      var _CONFIG$CHANNEL_CONFI = _mainConfig.default.CHANNEL_CONFIG,
        loggedInCsc = _CONFIG$CHANNEL_CONFI.loggedInCsc,
        portal = _CONFIG$CHANNEL_CONFI.portal;
      var isCiam = (url === null || url === void 0 ? void 0 : url.includes(middlewareDomains.cscnAccountDomain)) || (url === null || url === void 0 ? void 0 : url.includes(middlewareDomains.account));
      var isCsc = url === null || url === void 0 ? void 0 : url.includes(middlewareDomains.cscnCustomerDomain);
      var headers = _objectSpread(_objectSpread(_objectSpread({
        'Content-Type': 'application/json'
      }, config.headers), setAuth ? this.getAuthHeader(isCiam) : {}), {}, {
        'X-Client': (_config$headers$XCli = (_config$headers = config.headers) === null || _config$headers === void 0 ? void 0 : _config$headers['X-Client']) !== null && _config$headers$XCli !== void 0 ? _config$headers$XCli : isCsc ? loggedInCsc : portal
      });
      return _objectSpread(_objectSpread({}, config), {}, {
        headers: headers,
        timeout: apiTimeoutInMilliseconds
      });
    }
  }, {
    key: "errorHandler",
    value: function errorHandler(error) {
      try {
        if (error.response) {
          this.refreshTokens(error.response);
          // The request was made, but the server responded with a status code
          // that falls out of the range of 2xx   );

          if (error.response.status === 401) {
            var errorCode = error.response.data && error.response.data.statusInfo && error.response.data.statusInfo.code;
            /* When user with an XID log's in to cscn portal - capture the api error
               and navigate to portal unlock page */
            if (errorCode === 'global.error.incompleteUser') {
              var locationPage = location.pathname.substring(location.pathname.lastIndexOf('/') + 1);
              var configPage = _mainConfig.default.AEM_CONFIG.portalUnlockRedirectUrl.split('/').slice(-1)[0];
              if (locationPage !== configPage) {
                if (_SessionHandler.default.getLoginType() !== _SessionHandler.loginTypes.callCenter) {
                  _SessionHandler.default.setLoginType(_SessionHandler.loginTypes.incompleteLoggedIn);
                }
                location.replace(_mainConfig.default.AEM_CONFIG.portalUnlockRedirectUrl);
              }
            } else {
              // @TODO exception has to be disabled until CSC MW is accepting salesforce token
              var newExp = new _Unauthenticated.default();
              newExp.loginType = _SessionHandler.default.getLoginType();
              throw newExp;
            }
          } else if (error.response.status === 403) {
            var _newExp = new _Unauthorized.default();
            _newExp.loginType = _SessionHandler.default.getLoginType();
            throw _newExp;
          }
        }
      } catch (exception) {
        _GlobalErrorHandler.default.handleException(exception);
      }
    }
  }, {
    key: "handleAxiosError",
    value: function handleAxiosError(error, useErrorHandler) {
      if (error.code === _axios.AxiosError.ECONNABORTED) {
        _GlobalErrorHandler.default.handleException(new _MyNetworkError.default());
      } else if (useErrorHandler) {
        this.errorHandler(error);
      }
    }

    // TODO: remove params
  }, {
    key: "get",
    value: function get(url) {
      var _this2 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var useErrorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var request = _axios.default.get(url, this.setConfig(config, auth, url));
      request.then(function (response) {
        _this2.refreshTokens(response);
      }).catch(function (error) {
        _this2.handleAxiosError(error, useErrorHandler);
      });
      return request;
    }
  }, {
    key: "postFile",
    value: function postFile(url, params) {
      var _this3 = this;
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var request = _axios.default.post(url, params, this.setConfig(config, false, url));
      request.catch(function (error) {
        _this3.handleAxiosError(error, true);
      });
      return request;
    }
  }, {
    key: "post",
    value: function post(url, params) {
      var _this4 = this;
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var useErrorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var request = _axios.default.post(url, params, this.setConfig(config, auth, url));
      request.then(function (response) {
        _this4.refreshTokens(response);
        return response;
      }).catch(function (error) {
        _this4.handleAxiosError(error, useErrorHandler);
      });
      return request;
    }
  }, {
    key: "put",
    value: function put(url, params) {
      var _this5 = this;
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var useErrorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var request = _axios.default.put(url, params, this.setConfig(config, auth, url));
      request.then(function (response) {
        _this5.refreshTokens(response);
        return response;
      }).catch(function (error) {
        _this5.handleAxiosError(error, useErrorHandler);
      });
      return request;
    }
  }, {
    key: "patch",
    value: function patch(url, params) {
      var _this6 = this;
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var useErrorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var request = _axios.default.patch(url, params, this.setConfig(config, auth, url));
      request.then(function (response) {
        _this6.refreshTokens(response);
      }).catch(function (error) {
        _this6.handleAxiosError(error, useErrorHandler);
      });
      return request;
    }
  }, {
    key: "delete",
    value: function _delete(url) {
      var _this7 = this;
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var useErrorHandler = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
      var auth = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
      var request = _axios.default.delete(url, _objectSpread(_objectSpread({}, this.setConfig(config, auth, url)), {}, {
        data: params
      }));
      request.then(function (response) {
        _this7.refreshTokens(response);
      }).catch(function (error) {
        _this7.handleAxiosError(error, useErrorHandler);
      });
      return request;
    }
  }, {
    key: "getJsonP",
    value: function getJsonP(url) {
      var result = (0, _fetchJsonp.default)(url, {
        timeout: 3000
      });
      result.then(function (response) {
        return response.json();
      }).catch(function (ex) {
        document.body.innerHTML = "failed: ".concat(ex);
      });
      return result;
    }
  }, {
    key: "downloadContentWithPost",
    value: function downloadContentWithPost(id, url) {
      var inputs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
      var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : function () {};
      var token = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : _SessionHandler.default.getToken();
      try {
        var _elementToRemove$pare;
        var pdfForm = document.createElement('form');
        pdfForm.name = 'downloadPdf';
        pdfForm.id = id;
        pdfForm.method = 'POST';
        pdfForm.action = url;
        var tokenInput = document.createElement('input');
        tokenInput.type = 'hidden';
        tokenInput.name = 'Bearer';
        tokenInput.value = token;
        pdfForm.appendChild(tokenInput);
        if (inputs.length) {
          inputs.forEach(function (elem) {
            var input = document.createElement('input');
            input.type = 'hidden';
            input.name = elem.name;
            input.value = elem.value;
            pdfForm.appendChild(input);
          });
        }
        document.body.appendChild(pdfForm);
        pdfForm.submit();
        var elementToRemove = document.getElementById(id);
        elementToRemove === null || elementToRemove === void 0 ? void 0 : (_elementToRemove$pare = elementToRemove.parentNode) === null || _elementToRemove$pare === void 0 ? void 0 : _elementToRemove$pare.removeChild(elementToRemove);
        if (typeof callback === 'function') {
          callback();
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    }
  }]);
  return RestHelper;
}();
(0, _defineProperty2.default)(RestHelper, "baseApiURLs", void 0);
var _default = exports.default = RestHelper;